import React, { useEffect, useState } from 'react'
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { config } from '../CommonUtils/CommonURLS';

export default function SubjectwiseReport() {

    const [projectdata, setProjectdata] = useState([]);
    const [subject, setSubject] = useState([]);
    const [showDetails, setShowDetails] = useState(false); // toggle between table 1 and table 2
    const [selectedUB, setSelectedUB] = useState(null);

    // Fetch first table data
    function GetProjectStatusData() {
        let url = `${config.url.FAC_URL}getUnvsubWiseReport`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" && res?.data?.UnivsubWiseReport?.length > 0) {
                setProjectdata(res?.data?.UnivsubWiseReport);
            } else {
                setProjectdata([]);
            }
        });
    }

    // Fetch second table data
    function GetSubjectData(ubcode, desg) {
        let url = `${config.url.FAC_URL}getSubjectwiseReport?ubCode=${ubcode}&desg=${desg}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" && res?.data?.subj_wise_details?.length > 0) {
                setSubject(res?.data?.subj_wise_details || []);
                setShowDetails(true); // show 2nd table
            } else {
                setSubject([]);
                setShowDetails(true); // still show empty table
            }
        });
    }

    useEffect(() => {
        GetProjectStatusData();
    }, []);

    const SubjectReportColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            id: "univ_name",
            header: "University Name",
            accessorKey: "univ_name",
            Footer: "Total",


        },
        {
            id: "professor_count",
            header: "Professors",
            accessorKey: "professor_count",
            cell: ({ row }) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <span
                        role="button"
                        tabIndex={0}
                        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                            GetSubjectData(row.original.ubcode, "Professor");
                            setSelectedUB(row.original.univ_name);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                GetSubjectData(row.original.ubcode, "Professor");
                                setSelectedUB(row.original.univ_name);
                            }
                        }}
                    >
                        {row?.original?.professor_count}
                    </span>
                </div>
            ),
            Footer: true,
        },
        {
            id: "associate_count",
            header: "Associate Professors",
            accessorKey: "associate_count",
            cell: ({ row }) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <span
                        role="button"
                        tabIndex={0}
                        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                            GetSubjectData(row.original.ubcode, "Associate Professor");
                            setSelectedUB(row.original.univ_name);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                GetSubjectData(row.original.ubcode, "Associate Professor");
                                setSelectedUB(row.original.univ_name);
                            }
                        }}
                    >
                        {row.original.associate_count}
                    </span>
                </div>
            ),
            Footer: true,
        },
        {
            id: "assistant_count",
            header: "Assistant Professors",
            accessorKey: "assistant_count",
            cell: ({ row }) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <span
                        role="button"
                        tabIndex={0}
                        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                            GetSubjectData(row.original.ubcode, "Assistant Professor");
                            setSelectedUB(row.original.univ_name);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                GetSubjectData(row.original.ubcode, "Assistant Professor");
                                setSelectedUB(row.original.univ_name);
                            }
                        }}
                    >
                        {row.original.assistant_count}
                    </span>
                </div>
            ),
            Footer: true,
        },


        {

            id: "total",
            header: "Total",
            accessorKey: "total",
            Footer: true,
            cell: ({ row }) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <span
                        role="button"
                        tabIndex={0}
                        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                            GetSubjectData(row.original.ubcode, "all");
                            setSelectedUB(row.original.univ_name);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                GetSubjectData(row.original.ubcode, "all");
                                setSelectedUB(row.original.univ_name);
                            }
                        }}
                    >
                        {row.original.total}
                    </span>
                </div>
            ),

        },


    ];

    const SubjectDetailsColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            id: "dept_name",
            header: "Department Name",
            accessorKey: "dept_name",
            Footer: "Total",

        },
        {
            id: "designation",
            header: "Designation",
            accessorKey: "designation",
        },
        {
            id: "no_of_san_posts",
            header: "No of Sanctioned Posts",
            accessorKey: "no_of_san_posts",
            Footer: true,

        },

        {
            id: "no_of_adhoc_fac_working",
            header: "No of Adhoc Faculty Working",
            accessorKey: "no_of_adhoc_fac_working",
            Footer: true,

        },

        {
            id: "no_of_guest_fac_working",
            header: "No of Guest Faculty Working",
            accessorKey: "no_of_guest_fac_working",
            Footer: true,

        },
        {
            id: "no_of_reg_fac_working",
            header: "No of Regular Faculty Working",
            accessorKey: "no_of_reg_fac_working",
            Footer: true,

        },
        {
            id: "no_of_contract_fac_working",
            header: "No of Contract Faculty Working",
            accessorKey: "no_of_contract_fac_working",
            Footer: true,

        },



    ];

    return (
        <div className="faculty-form-wrapper">
            <div className="faculty-card">

                {/* Table 1 */}
                {!showDetails && projectdata?.length > 0 && (
                    <>
                        <div className="overal-stathead">
                            <span>University wise Subject Report</span>
                        </div>
                        <div className="table-responsive">
                            <CommonReactTable
                                data={projectdata}
                                columns={SubjectReportColumns}
                                filename="Subject wise Report"
                                headerName="Subject wise Report"
                                showFooter={true}
                                showExcel={true}
                                showPrint={true}
                                showPagination={false}
                                excelFileName="Subject wise Report"
                            />
                        </div>
                    </>
                )}

                {/* Table 2 */}
                {showDetails && (
                    <>

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div className="overal-stathead">
                                <span>{selectedUB} - Subject Details Report</span>
                            </div>

                            <button type='button'
                                className="btn btn-primary"

                                style={{ marginBottom: "0px" }}
                                onClick={() => setShowDetails(false)}
                            >
                                Back
                            </button>
                        </div>
                        <div className="table-responsive">
                            <CommonReactTable
                                data={subject}
                                columns={SubjectDetailsColumns}
                                filename="Subject Details Report"
                                headerName="Subject Details Report"
                                showFooter={true}
                                showExcel={true}
                                showPrint={true}
                                showPagination={false}
                                excelFileName="Subject Details Report"
                            />
                        </div>
                    </>
                )}

            </div>
        </div>
    )
}



